<template>
  <div class="employeeslist">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Probated Employees</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Probated Employees</li>
                </ul>
              </div>
            </div>
          </div>

          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <v-data-table
                :headers="headers"
                :items="probatedEmployees"
                :loading="loading"
                loading-text="Loading... Please wait"
                sort-by=""
                class="elevation-1 table"
              >
                <template v-slot:[`item.profile`]="{ item }">
                  <h2 class="table-avatar">
                    <router-link
                      :to="{
                        name: 'employeedetail',
                        params: { id: item.employee.id },
                      }"
                      class="avatar"
                      ><img
                        alt=""
                        src="~@/assets/profiles/avatar-02.jpg"
                        v-if="!item.employee.passportPhoto" />
                      <img
                        alt=""
                        :src="media + item.employee.passportPhoto"
                        width="38"
                        v-if="item.employee.passportPhoto"
                    /></router-link>
                    <router-link
                      :to="{
                        name: 'employeedetail',
                        params: { id: item.employee.id },
                      }"
                      v-if="item.employee.status == 3"
                      ><p>
                        {{
                          item.employee.firstName + " " + item.employee.lastName
                        }}
                      </p>
                      <span>{{ item.employee.designation.name }}</span>
                    </router-link>
                    <router-link
                      :to="{
                        name: 'employeedetail',
                        params: { id: item.employee.id },
                      }"
                      v-else
                      >{{
                        item.employee.firstName + " " + item.employee.lastName
                      }}
                      <span>{{ item.employee.designation.name }}</span>
                    </router-link>
                  </h2>
                </template>
                <template v-slot:[`item.startDate`]="{ item }">
                  {{
                    item.startDate
                      ? new Date(item.startDate).toLocaleDateString()
                      : ""
                  }}
                </template>

                <template v-slot:[`item.endDate`]="{ item }">
                  {{
                    item.endDate
                      ? new Date(item.endDate).toLocaleDateString()
                      : ""
                  }}
                </template>
                <template v-slot:[`item.employeeCode`]="{ item }">
                  {{ company.abbrv + "-" + item.id }}
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                  <div class="dropdown dropdown-action">
                    <a
                      href="#"
                      class="action-icon dropdown-toggle"
                      data-toggle="dropdown"
                      aria-expanded="false"
                      ><i class="material-icons">more_vert</i></a
                    >
                    <div class="dropdown-menu dropdown-menu-right">
                      <a
                        class="dropdown-item"
                        @click="setProbatedEmployeeExtension(item)"
                        data-toggle="modal"
                        data-target="#edit_employee"
                        v-if="item.probatedExtension == null"
                      >
                        Extend
                      </a>
                      <a
                        class="dropdown-item"
                        @click="setProbatedEmployeeConfirmation(item)"
                        data-toggle="modal"
                        data-target="#edit_employee"
                        v-if="item.probatedExtension == null"
                      >
                        Confirm
                      </a>
                    </div>
                  </div>
                </template>
              </v-data-table>
            </div>
          </div>
          <!---/Datatable-->
        </div>
        <!-- /Page Content -->

        <!-- Extend Employee probation period Modal -->
        <v-dialog v-model="dialogEdit" max-width="350px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Probation Extension</h5>
              <button
                type="button"
                class="close"
                aria-label="Close"
                @click="close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="onExtensionOfProbation">
                <div class="row">
                  <div class="col-md-12">
                    <div
                      class="alert alert-danger alert-dismissible fade show"
                      role="alert"
                      v-if="error"
                    >
                      <strong>Error!</strong> {{ error }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div
                      class="alert alert-success alert-dismissible fade show"
                      role="alert"
                      v-if="message"
                    >
                      <strong>Success!</strong> {{ message }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="form-group">
                      <label class="col-form-label"
                        >Extend Probation Date
                      </label>

                      <select
                        name=""
                        id=""
                        class="form-control"
                        v-model="probationExtensionMonth"
                      >
                        <option value="">Select Extension month</option>
                        <option value="1">1 month</option>
                        <option value="2">2 months</option>
                        <option value="3">3 months</option>
                        <option value="4">4 months</option>
                        <option value="5">5 months</option>
                        <option value="6">6 months</option>
                        <option value="7">7 months</option>
                        <option value="8">8 months</option>
                        <option value="9">9 months</option>
                        <option value="10">10 months</option>
                        <option value="11">11 months</option>
                        <option value="12">12 months</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-group">
                      <label class="col-form-label"
                        >Reasons for probation extension</label
                      >

                      <textarea
                        v-model="employee.comment"
                        v-if="employee"
                        class="textarea-box"
                      >
                      </textarea>
                    </div>
                  </div>
                </div>
                <div class="submit-section">
                  <button class="btn btn-primary submit-btn" type="submit">
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- /Extend Employee probation period Modal -->

        <!-- Confirm Employee probation Modal -->
        <v-dialog v-model="dialogConfirm" max-width="350px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Probation Confirmation</h5>
              <button
                type="button"
                class="close"
                aria-label="Close"
                @click="closeConfirmation"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="onConfirmationOfProbation">
                <div class="row">
                  <div class="col-md-12">
                    <div
                      class="alert alert-danger alert-dismissible fade show"
                      role="alert"
                      v-if="error"
                    >
                      <strong>Error!</strong> {{ error }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div
                      class="alert alert-success alert-dismissible fade show"
                      role="alert"
                      v-if="message"
                    >
                      <strong>Success!</strong> {{ message }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="form-group">
                      <label class="col-form-label">Confirmtion Comment</label>
                      <textarea
                        v-model="comment"
                        v-if="employee"
                        class="textarea-box"
                      >
                      </textarea>
                    </div>
                  </div>
                </div>
                <div class="submit-section">
                  <button class="btn btn-primary submit-btn" type="submit">
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- /Confirm Employee probation Modal -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/employeeSidebar.vue";
import { required, numeric, sameAs } from "vuelidate/lib/validators";
import { employeeService } from "@/services/employeeService.js";
import { authenticationService } from "@/services/authenticationService";
import { organizationService } from "@/services/organizationService";
import Datepicker from "vuejs-datepicker";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Datepicker,
  },
  data() {
    return {
      company: authenticationService.currentOfficeValue,
      firstName: "",
      lastName: "",
      rankId: null,
      address: "",
      phone: "",
      email: "",
      requestDate: new Date(),
      designationId: null,
      companyunitId: null,
      media: "data:image/jpeg;base64,",
      headers: [
        {
          text: "Name",
          value: "profile",
        },
        { text: "Employee Code", value: "employeeCode" },
        { text: "Bus. Unit", value: "employee.companyUnit.name" },
        { text: "Email", value: "employee.email" },
        { text: "Mobile", value: "employee.phone" },
        { text: "Join Date", value: "startDate" },
        { text: "End Date", value: "endDate" },
        { text: "Gender", value: "employee.gender" },
        { text: "Action", value: "actions", sortable: false },
      ],
      probatedEmployees: [],
      employee: {},
      submitted: false,
      loading: false,
      error: "",
      message: "",
      dialog: false,
      dialogEdit: false,
      dialogConfirm: false,
      dialogDelete: false,
      dialogImport: false,
      fileName: "",
      comment: "",
      probationExtensionMonth: "",
      currentUserId: {},
      currentUserFullName: "",
      currUserData: {},
    };
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    // dialogEdit(val) {
    //   val || this.closeEdit();
    // },
  },
  created() {
    this.getCurrentUser();
  },

  methods: {
    getProbatedEmployees() {
      this.loading = true;
      let currentUserDepart = JSON.parse(localStorage.getItem("currentUser"));
      employeeService
        .GetProbatedEmployees(
          currentUserDepart.employee.designation.departmentId,
          currentUserDepart.employee.companyUnitId
        )
        .then(
          (model) => {
            console.log(model);
            this.probatedEmployees = model.filter((k) => k.status == 0);
          },
          (error) => {
            this.error = error;
            this.loading = false;
          }
        );
    },

    getCurrentUser() {
      let currentUser = JSON.parse(localStorage.getItem("currentUser"));
      this.currentUserId = currentUser.employee;
      this.currentUserFullName =
        currentUser.employee.firstName + " " + currentUser.employee.lastName;
      console.log(this.currentUserId);
    },

    setProbatedEmployeeExtension(model) {
      this.employee = model;
      this.dialogEdit = true;
    },

    setProbatedEmployeeConfirmation(model) {
      this.employee = model;
      this.dialogConfirm = true;
      console.log(this.employee);
    },

    onConfirmationOfProbation() {
      this.submitted = true;
      const id = this.employee.id;
      this.employee.approvedByHOD = this.currentUserId.id;
      this.employee.hodComments = this.comment;
      this.employee.approvedDateByHOD = this.requestDate;
      employeeService
        .updateProbatedEmployeeOnConfirmation(id, this.employee)
        .then(
          (id) => {
            this.message = "Employee update successfully";
            var unit = JSON.parse(localStorage.getItem("currentUser"));
            employeeService
              .getProbatedEmployees(unit.employee.designation.departmentId,
          unit.employee.companyUnitId)
              .then((model) => {
                this.employees = model.filter((k) => k.status == 0);
                //this.message = '';
                this.dialogConfirm = false;
              });
          },
          (error) => {
            this.error = error;
            this.loading = false;
          }
        );
    },
    onExtensionOfProbation() {
      this.submitted = true;
      employeeService
        .extendProbationTo(
          this.currentUserFullName,
          this.employee.comment,
          this.employee.id,
          Number(this.probationExtensionMonth),
          this.requestDate,
          this.currentUserId.id
        )
        .then(() => {
          this.dialogEdit = false;
        });
    },

    close() {
      this.dialogEdit = false;
      // this.clearModel();
    },
    closeConfirmation() {
      this.dialogConfirm = false;
      // this.clearModel();
    },

    openDialog() {
      this.dialog = true;
    },

    closeDelete() {
      this.dialogDelete = false;
    },
  },

  mounted() {
    this.getProbatedEmployees();
  },
  name: "employeeslist",
};
</script>


// WEBPACK FOOTER //
// src/components/employees/ProbationList.vue